import { render, staticRenderFns } from "./agentinfoModel.vue?vue&type=template&id=452771bb&scoped=true"
import script from "./agentinfoModel.vue?vue&type=script&lang=js"
export * from "./agentinfoModel.vue?vue&type=script&lang=js"
import style0 from "./agentinfoModel.vue?vue&type=style&index=0&id=452771bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452771bb",
  null
  
)

export default component.exports